
import { defineComponent, onMounted, computed, ref, h, nextTick } from 'vue'
import { useRouter } from 'vue-router'
import { openTab, ITabInterface } from '@/Tool/event'
import { $t as lang, formatUrl } from '@/Tool'
import { setMenuAndSubmenu, tabIsInMenus } from '@/Tool/index'
import GuijiLayout from '@/finiteComponents/Layout/index.vue'
import { startQiankun } from '@/qiankun'
import { ElTabs, ElTabPane, ElMessageBox, ElPopover, ElBadge, ElEmpty } from 'element-plus'
import vuex from '@/store'
import { ElMessageBoxOptions } from 'element-plus/packages/message-box/src/message-box.type'
import { loginOut, getUserTypes, partnerDetail, changeRole, SystemMessage } from '@/Tool/LoginSet'
import Store from '@/finiteComponents/Layout/LeftNav/store'
import Vuex from '@/store'
import MICRO_CONF from './../../qiankun/config'
import service from '@/services'
import { removeParamAndRefresh } from '@/Tool/index'
import { getLang } from '@/services/apis/lang'
import PrivacyModal from '@/components/PrivacyModal.vue'

export default defineComponent({
  components: {
    GuijiLayout,
    ElTabs,
    ElTabPane,
    ElPopover,
    ElBadge,
    ElEmpty,
    PrivacyModal,
    // DeleteAccountModal,
    // DeleteConfirmModal,
  },
  setup() {
    const language = localStorage.getItem('lang') || navigator.language.substr(0, 2)
    const tabsArr = computed(() => vuex.state.tabsArr)
    const activeTab = computed(() => vuex.state.activeTabName)
    const menus = computed(() => vuex.state.menus)
    const popoverVisible = ref(false)
    const messagePopoverVisible = ref(false)
    const problemPopoverVisible = ref(false)
    const destroyId = ref(0)
    const destroyTime = ref('')
    const showDeleteAccountModal = ref(false)
    const showConfirmDeleteModal = ref(false)
    const router = useRouter()
    const currentMicro = computed(() => vuex.state.currentMicroDom)
    const systemMessage = computed(() => vuex.state.systemMessage)
    const formatSysMessageList = computed(() =>
      vuex.state.systemMessage.message.content.split('\n'),
    )
    const noDataDes = computed(() => lang('mainAccount.info.noData'))
    const roles = ref([])
    const partnerInfo = ref(null)
    const vipInfo = ref(null)
    const countdown = ref(0)
    const ownTime = ref(0)
    const days = ref(14)
    const overdueTime = ref(0)
    const chromeLang = ref(language)
    const privacyVisible = ref(false)
    const equityList = [
      {
        title: lang('home.eq.tit[1]'),
        content: lang('home.eq.val[1]'),
        url: require('@/assets/images/meta/q1.png'),
      },
      {
        title: lang('home.eq.tit[2]'),
        content: lang('home.eq.val[2]'),
        url: require('@/assets/images/meta/q4.png'),
      },
      {
        title: lang('home.eq.tit[3]'),
        content: lang('home.eq.val[3]'),
        url: require('@/assets/images/meta/q3.png'),
      },
      {
        title: lang('home.eq.tit[4]'),
        content: lang('home.eq.val[4]'),
        url: require('@/assets/images/meta/q7.png'),
      },
    ]

    getUserTypes().then((res) => {
      if (res.success) {
        roles.value = res.data
      }
    })

    partnerDetail().then((res) => {
      if (res.success) {
        partnerInfo.value = res.data || null
      }
    })

    const currRole = computed(() => {
      return roles.value.find((item: any) => {
        return item.type === vuex.state?.user?.info?.corpId
      })
    })

    onMounted(() => {
      service.ConfigServer.checkWhiteList({
        dictName: '小视频',
        childDictNameList: ['cancelTime'],
      }).then(({ success, data }) => {
        if (success) {
          const value = data.childOption.find((item) => 'cancelTime' === item.optionName)
          if (value) {
            days.value = value.optionValue
          }
        }
      })

      queryDetectStatus()
      startQiankun()
    })

    const queryDetectStatus = async () => {
      const { data, success } = await service.Scrm_sys_api.srcmLogin.getUserTypes({})
      if (success) {
        const { user } = JSON.parse(sessionStorage.__user || '{}')
        const currentRole = data.find((item) => item.type === user.orgid)
        destroyId.value = currentRole?.destroyId || 0
        destroyTime.value = currentRole?.destroyTime?.slice(0, 10) || ''

        vuex.commit('set_data', {
          detectStatus: destroyId.value > 0 ? 1 : 0,
        })
      }
    }
    function onTabClick(target: any) {
      const tabIndex = Number(target.index)
      const tabItem = vuex.state.tabsArr[tabIndex]
      vuex.commit('set_data', {
        currentMicroDom: tabItem.url,
      })
      if (!tabItem.isOutside) {
        Store.store.defaultActive = tabItem.key as string
        if (!tabItem.parentKey) {
          const tabMenu = menus.value.find((item) => item.key === tabItem.key)
          // 设置选中一级菜单
          if (tabMenu) {
            menus.value.forEach((item: any) => {
              item.isSelect = item.key === tabMenu.key
            })
          }
          Vuex.commit('set_data', {
            selectMenu: tabMenu,
            selectSubmenus: {},
            leftMenuCollapse: true,
          })
        } else {
          setMenuAndSubmenu(tabItem.parentKey)
          Vuex.commit('set_data', {
            leftMenuCollapse: false,
          })
        }
      } else {
        // 子系统之间跳转打开的tab带得标志，需要特殊处理
        const selectTabMenu = tabIsInMenus(tabItem.url)
        if (selectTabMenu.firstMenu || selectTabMenu.secondMenu) {
          const key = selectTabMenu.firstMenu?.key || selectTabMenu.secondMenu?.key
          const parentKey =
            selectTabMenu.firstMenu?.parentKey || selectTabMenu.secondMenu?.parentKey
          Store.store.defaultActive = key as string

          if (selectTabMenu.firstMenu) {
            Vuex.commit('set_data', {
              selectSubmenus: selectTabMenu.firstMenu,
            })
          }
          if (selectTabMenu.secondMenu) {
            Vuex.commit('set_data', {
              leftMenuCollapse: false,
              selectSubmenus: selectTabMenu.secondMenu,
            })
            Vuex.state.menus.forEach((item: any) => {
              item.isSelect = item.key === selectTabMenu.firstMenu?.key
            })
          }
          //setMenuAndSubmenu(parentKey)
        } else {
          vuex.state.menus.forEach((item) => (item.isSelect = false))
          Vuex.commit('set_data', {
            selectSubmenus: {},
            leftMenuCollapse: true,
          })
        }
      }
      router.push({ path: tabItem.url })
      Vuex.commit('set_data', {
        activeTabName: tabItem.name,
        // 点击tab关闭二级菜单
        leftMenuCollapse: true,
      })
    }
    function handleTabsEdit(name: any) {
      const tabsArrs = vuex.state.tabsArr
      const index = tabsArrs.findIndex((item) => item.name === name)
      const nowTabsArr = tabsArrs.filter((item) => {
        return item.name !== tabsArrs[index].name
      })
      clearCache(name)
      // 判断是否需要关闭tab
      const currentTab = tabsArrs[index]
      if (currentTab.isEdit && currentTab.isEdit) {
        ElMessageBox.confirm(currentTab.message, {
          confirmButtonText: lang('mainTip.logout.confirm'),
          cancelButtonText: lang('mainTip.logout.cancel'),
          confirmButtonClass: 'BtnAlert',
        }).then(() => {
          closeTab(nowTabsArr, index)
          const event = new CustomEvent('CLOSE_TAB', {
            detail: {
              url: tabsArrs[index].url,
            },
          })
          window.dispatchEvent(event)
        })
      } else {
        closeTab(nowTabsArr, index)
        const event = new CustomEvent('CLOSE_TAB', {
          detail: {
            url: tabsArrs[index].url,
          },
        })
        window.dispatchEvent(event)
      }
    }
    function clearCache(name: any) {
      if (name.indexOf(lang('home.tab.pictureSpeak')) > -1) {
        localStorage.removeItem('chatImageVideo')
      }
    }
    function closeTab(nowTabsArr: any, index: any) {
      const tabItem = nowTabsArr[index - 1]
      if (!tabItem.isOutside) {
        Store.store.defaultActive = tabItem.key as string
        if (!tabItem.parentKey) {
          const tabMenu = menus.value.find((item) => item.key === tabItem.key)
          // 设置选中一级菜单
          if (tabMenu) {
            menus.value.forEach((item: any) => {
              item.isSelect = item.key === tabMenu.key
            })
          }
          Vuex.commit('set_data', {
            selectMenu: tabMenu,
            selectSubmenus: {},
            leftMenuCollapse: true,
          })
        } else {
          setMenuAndSubmenu(tabItem.parentKey)
          Vuex.commit('set_data', {
            leftMenuCollapse: true,
          })
        }
      } else {
        // 子系统之间跳转打开的tab带得标志，需要特殊处理
        const selectTabMenu = tabIsInMenus(tabItem.url)
        if (selectTabMenu.firstMenu || selectTabMenu.secondMenu) {
          const key = selectTabMenu.secondMenu?.key || selectTabMenu.firstMenu?.key
          const parentKey =
            selectTabMenu.secondMenu?.parentKey || selectTabMenu.firstMenu?.parentKey
          Store.store.defaultActive = key as string
          if (selectTabMenu.firstMenu) {
            Vuex.commit('set_data', {
              selectSubmenus: Vuex.state.subMenus[selectTabMenu.firstMenu?.key] || [],
            })
            Vuex.state.menus.forEach((item: any) => {
              item.isSelect = item.key === selectTabMenu.firstMenu.key
            })
          }
          if (selectTabMenu.secondMenu) {
            Vuex.commit('set_data', {
              leftMenuCollapse: true,
            })
          }
          // setMenuAndSubmenu(parentKey)
        }
      }
      // 关闭页签时，跳转到当前关闭页签的前一个页签
      router.push(tabItem.url)
      vuex.commit('set_data', {
        tabsArr: nowTabsArr,
        activeTabName: nowTabsArr[index - 1].name,
        currentMicroDom: tabItem.url,
      })
    }
    const nickname = computed(() => vuex.state.user && vuex.state.user.info?.nickname)
    const username = computed(() => vuex.state.user && vuex.state.user.info?.username)
    const corpName = computed(() => vuex.state.user && vuex.state.user.info?.username)
    async function logout() {
      try {
        await ElMessageBox.confirm(lang('mainTip.logout.content'), lang('mainTip.logout.title'), {
          confirmButtonText: lang('mainTip.logout.confirm'),
          cancelButtonText: lang('mainTip.logout.cancel'),
          confirmButtonClass: 'BtnAlert',
          type: 'warning',
        } as ElMessageBoxOptions)
        await loginOut(vuex.state.user.orgid as number)
      } catch (e) {
        console.log(e)
      }
    }
    function setting() {
      const tabItem: ITabInterface = {
        title: lang('mainMenu.basicInfo.title'),
        url: '/accountSetting',
      }
      openTab(tabItem)
    }

    // 会员订阅|续订
    function handleSubscribe() {
      window.postMessage({ subscribe: true }, '*')
    }
    // 会员订阅|续订记录
    function handleSubscribeTable() {
      window.postMessage({ subscribeTable: true }, '*')
    }
    //跳转官网
    function goToWebsite() {
      if (window.opener) {
        //判断是是否由父页面跳转而来
        window.open('javascript:;', window.opener.name)
        window.opener.focus()
      } else {
        //若不是则新开页面
        window.open(
          `${
            ['localhost', 'robot.guiji.ai', '172.16.103.12'].includes(location.hostname)
              ? 'https://robot.guiji.ai:10081/zh/index'
              : 'https://vshow.guiji.ai/vshow-website/index'
          }${
            vuex.state.user.token
              ? `?token=${vuex.state.user.token}&userId=${vuex.state.user.info.userId}`
              : ''
          }`,
          '_blank',
        )
      }
    }

    // 未读消息，展示最近的 8 条
    const unReadMessageList = ref([])

    function handleShowMessage() {
      service.MessageApi.queryMessageList({
        data: {
          asc: true,
          page: 1,
          size: 8,
          readFlag: 0, // 未读：0，已读：1
        },
      }).then((resp) => {
        const { data } = resp
        unReadMessageList.value = data['records'] || []
        messagePopoverVisible.value = true
      })
    }

    function handleViewMessage(id?: any) {
      const tabItem: ITabInterface = {
        title: lang('mainMenu.myMenu.messageCenter'),
        url: `/messageCenter`,
      }
      messagePopoverVisible.value = false
      vuex.commit('set_data', {
        checkedMessageId: id,
      })
      openTab(tabItem)
    }
    // 已读消息或者关闭消息
    function hasReadMessage() {
      const FuncSystemMessage = new SystemMessage({})
      service.MessageApi.saveMessageRecord({
        data: {
          messageIds: [vuex.state.systemMessage.message.id],
        },
      }).then(() => {
        FuncSystemMessage.getMessageInfo(vuex.state.user.info.userId)
        vuex.commit('set_data', {
          checkedBroadcastId: vuex.state.systemMessage.message.id,
        })
      })
    }
    function handleOpenMessageLink() {
      window.open(formatUrl('cdn', vuex.state.systemMessage.message.attachmentUrl), '_blank')
      hasReadMessage()
    }
    function handleShowNotice() {
      const FuncSystemMessage = new SystemMessage({})
      ElMessageBox({
        title: vuex.state.systemMessage.message.title,
        customClass: 'update-notice',
        message: h('div', null, [
          h(
            'div',
            {
              style:
                'white-space: pre-wrap;font-size: 14px;text-align: left;line-height: 2;margin: 10px 0 40px',
            },
            [
              vuex.state.systemMessage.message.content,
              vuex.state.systemMessage.message.attachmentDesc
                ? h(
                    'p',
                    {
                      style:
                        'margin-top: 10px;white-space: normal;color: #5778fb;text-decoration: underline;cursor: pointer;',
                      onClick: () =>
                        window.open(
                          formatUrl('cdn', vuex.state.systemMessage.message.attachmentUrl),
                          '_blank',
                        ),
                    },
                    vuex.state.systemMessage.message.attachmentDesc,
                  )
                : null,
            ],
          ),
        ]),
        showCancelButton: false,
        showClose: false,
        confirmButtonText: lang('home.btn.Ican'),
        dangerouslyUseHTMLString: true,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        center: true,
      }).then(() => {
        service.MessageApi.saveMessageRecord({
          data: {
            messageIds: [vuex.state.systemMessage.message.id],
          },
        }).then(() => {
          FuncSystemMessage.getMessageInfo(vuex.state.user.info.userId)
          vuex.commit('set_data', {
            checkedBroadcastId: vuex.state.systemMessage.message.id,
          })
        })
      })
    }

    async function handleDeleteAccount() {
      vuex.commit('set_data', {
        showDetectAccountModal: true,
      })
      await queryDetectStatus()
    }

    function handleOpenTab(tab: ITabInterface) {
      openTab(tab)
      popoverVisible.value = false
    }

    function handleOpenUrl(url: string) {
      window.open(url, '_blank')
      problemPopoverVisible.value = false
    }

    function handleViewDetail() {
      console.log(vuex.state.systemMessage.message.attachmentDesc)
    }

    function handleConfirm() {
      showConfirmDeleteModal.value = true
      showDeleteAccountModal.value = false
    }

    function handleUndoSuccess() {
      showConfirmDeleteModal.value = false
    }

    function TranslationTitle(T) {
      let type = {
        1: lang('home.month'),
        2: lang('home.quarter'),
        3: lang('home.year'),
      }
      return T.subscribe
        ? lang('home.continuous', [type[T.subscribeType]])
        : lang('home.vip.des', [type[T.subscribeType]])
    }

    function handleOpenPrivacy() {
      privacyVisible.value = true
    }

    // 切换中英文
    const langChange = async (langs) => {
      localStorage.setItem('lang', langs)
      getLang().then((res) => {
        const obj = {}
        for (let key in res.data) {
          obj[res.data[key]] = key
        }
        getLang(langs).then((rel) => {
          const tabArr = vuex.state.tabsArr.map((li) => {
            const arr = li.name.split('&')
            let name = arr[0]
            if (arr.length > 1) {
              if (obj[name]) {
                name = obj[name]
                li.name = `${rel.data[name]}&${arr[1]}`
              }
            }
            return li
          })
          vuex.commit('set_data', {
            tabsArr: tabArr,
          })
          nextTick(() => {
            removeParamAndRefresh('token')
          })
        })
      })
    }

    return {
      chromeLang,
      popoverVisible,
      messagePopoverVisible,
      activeTab,
      tabsArr,
      nickname,
      username,
      corpName,
      noDataDes,
      roles,
      days,
      partnerInfo,
      vipInfo,
      countdown,
      ownTime,
      overdueTime,
      equityList,
      currRole,
      MICRO_CONF,
      currentMicro,
      systemMessage,
      formatSysMessageList,
      unReadMessageList,
      problemPopoverVisible,
      destroyId,
      destroyTime,
      privacyVisible,
      showDeleteAccountModal,
      showConfirmDeleteModal,
      handleUndoSuccess,
      router,
      handleTabsEdit,
      onTabClick,
      logout,
      setting,
      goToWebsite,
      handleSubscribe,
      handleSubscribeTable,
      lang,
      handleShowMessage,
      handleViewMessage,
      handleShowNotice,
      handleDeleteAccount,
      handleConfirm,
      handleOpenMessageLink,
      hasReadMessage,
      handleOpenTab,
      handleOpenUrl,
      handleViewDetail,
      changeRole,
      // getUserInfo,
      TranslationTitle,
      langChange,
      handleOpenPrivacy,
    }
  },
})
